import React from 'react';
import './ExternalModal.scss'
import {ReactComponent as CloseIcon} from "../../assets/icons/close.svg";

const ExternalModal = props =>  {
    const {closeMethod, title, children, messageModal} = props;

    return (
        <div className="ExternalModal">
            <div className="externalModalWindow" style={!messageModal ? {'overflowY':'auto'} : null}>
                <div className="externalModalWrapper">
                    {!messageModal && (
                        <div className="externalModalHeader">
                            <h1>{title}</h1>
                            <div
                                onClick={closeMethod}
                                className='closeButtonHolder'>
                                <CloseIcon  />
                            </div>
                        </div>
                    )}
                    <div className="externalModalContent">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ExternalModal;
